@if (useTextArea && useJsonValidator) {
  <div class="json-validator-toggle">
    <mat-slide-toggle #validatorToggle [(ngModel)]="jsonValidatorEnabled" (change)="onToggleValidation()">
      {{ 'MagicVariables.DisableValidatorCheckbox' | translate: locale.language }}
    </mat-slide-toggle>
  </div>
  @if (!jsonValidatorEnabled) {
    <div class="pad-bottom-1rem">
      <app-info-card [hideTitle]="true" [level]="'warning'">
        <i>
          {{ 'MagicVariables.DisableValidatorWarning' | translate: locale.language }}
        </i>
        <button mat-stroked-button (click)="manualValidationCheck()">
          {{ 'MagicVariables.ValidateJson' | translate: locale.language }}
        </button>
      </app-info-card>
    </div>
  }
  @if (useJsonValidator && jsonInvalid) {
    <mat-card appearance="outlined" class="json-error">
      <mat-error>{{ jsonError }}</mat-error>
    </mat-card>
  }
}
<mat-form-field appearance="outline">
  <mat-label>
    @if (useTextArea && useJsonValidator) {
      <mat-icon [class]="jsonInvalid ? 'invalid' : 'valid'">
        {{ jsonInvalid ? 'cancel' : 'check_circle' }}
      </mat-icon>
    }
    {{ placeholder }}
  </mat-label>
  @if (useTextArea) {
    <textarea
      #textareaEl
      matInput
      [formControl]="inputControl"
      (keydown)="setCursorPositionOnKeyEvent($event)"
      (keyup)="setCursorPositionOnKeyEvent($event)"
      (click)="setCursorPositionOnClickEvent($event)">
    </textarea>
  } @else {
    <input
      matInput
      [formControl]="inputControl"
      (keydown)="setCursorPositionOnKeyEvent($event)"
      (keyup)="setCursorPositionOnKeyEvent($event)"
      (click)="setCursorPositionOnClickEvent($event)" />
  }
  @if (!useTextArea && magicNestedProperties?.length && showHint) {
    <mat-hint>
      {{ 'MagicVariables.FieldHint' | translate: locale.language }}
    </mat-hint>
  }
  @if (!useTextArea && magicNestedProperties?.length) {
    <button
      mat-icon-button
      matSuffix
      [matTooltip]="'MagicVariables.Button' | translate: locale.language"
      (click)="launchDialog()"
      [attr.aria-label]="'MagicVariables.Button' | translate: locale.language">
      <mat-icon>generating_tokens</mat-icon>
    </button>
  }
  @if (!useTextArea) {
    <button
      mat-icon-button
      matSuffix
      [matTooltip]="'MagicVariables.ClearButtonTooltip' | translate: locale.language"
      (click)="inputControl.reset()"
      [attr.aria-label]="'Clear' | translate: locale.language">
      <mat-icon>clear</mat-icon>
    </button>
  }
  @if (!useTextArea && showDeleteButton) {
    <button
      mat-icon-button
      matSuffix
      [matTooltip]="removeButtonTooltipTranslated"
      (click)="onDeleteClick()"
      [attr.aria-label]="removeButtonTooltipTranslated">
      <mat-icon>delete</mat-icon>
    </button>
  }
</mat-form-field>
@if (useTextArea) {
  @if (magicNestedProperties) {
    <button color="primary" mat-stroked-button (click)="launchDialog()">
      <mat-icon>generating_tokens</mat-icon>
      <span>{{ 'MagicVariables.Button' | translate: locale.language }}</span>
    </button>
  }
  <button mat-stroked-button (click)="inputControl.reset()">
    <mat-icon>clear</mat-icon>
    <span>{{ 'Clear' | translate: locale.language }}</span>
  </button>
}
<ng-template #magicVariablesDialog>
  <div mat-dialog-title>{{ 'MagicVariables.DialogTitle' | translate: locale.language }}</div>
  <div mat-dialog-content>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
      <!-- This is the tree node template for leaf nodes -->
      <!-- There is inline padding applied to this node using styles.
          This padding value depends on the mat-icon-button width. -->
      <mat-tree-node
        (keypress)="insertMagicVariable(node.replacementKey)"
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        (click)="insertMagicVariable(node.replacementKey)">
        <div class="tree-item">{{ node.name }}</div>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node class="tree-node-with-padding" *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          {{ node.name }}
        </div>
        <!-- There is inline padding applied to this div using styles.
          This padding value depends on the mat-icon-button width.  -->
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>
      {{ 'Cancel' | translate: locale.language }}
    </button>
  </div>
</ng-template>
